export class Server{
    // url = "http://localhost:8000/uploads";
    url = "https://backend.hellindafarms.com/uploads";
}